import { __rest } from "tslib";
import React, { useState, useEffect, useMemo, useCallback, useImperativeHandle, useRef } from 'react';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import { EnhanceSelect } from '@web-common/components/UI/Select';
import classnames from 'classnames';
import styles from './index.module.scss';
import { apis, api, getIn18Text, emailPattern, zhPattern, isElectron, } from 'api';
import { AutoComplete, Form, message } from 'antd';
import Input from '@web-common/components/UI/Input';
import { TongyongJiantou1Xia } from '@sirius/icons';
import { TongyongJiantou1Shang } from '@sirius/icons';
import Button from '@lingxi-common-component/sirius-ui/Button';
import { getAccountType, getAuthCodeMap, getBindAccountInfo, getBindEmailMessage } from './data';
import useRisk from '@web-common/hooks/useRisk';
import { getEmailSuffix, sendAddAccountTrack } from '@web-common/components/util/webmail-util';
import { TongyongCuowutishiMian } from '@sirius/icons';
const productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.getSystemApi();
const trackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const eventApi = api.getEventApi();
const accountList = ['NeteaseQiYeMail', '163Mail', '126Mail', 'QQMail', 'TencentQiye', 'Gmail', 'Others'];
const domainList = [
    '163.com',
    '126.com',
    'qq.com',
    'foxmail.com',
    'gmail.com',
    'yeah.net',
    'sina.com',
    '139.com',
    '189.cn',
];
const MultAccountsLogin = props => {
    const [accountTypes, setAccountTypes] = useState(accountList);
    const { closeModel, loginInfo, renderTitle, renderSubTitle, successMessage, initStepData, setInitStepData } = props;
    const [accountType, setAccountType] = useState('Others');
    const { riskManage } = useRisk();
    const authMap = useRef();
    const [authUrl, setAuthUrl] = useState();
    const [visibleSetting, setVisibleSetting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState('inputAccount');
    const [form] = Form.useForm();
    const [errMsg, setErrMsg] = useState();
    const [settingError, setSettingError] = useState();
    const [mobile, setMobile] = useState();
    const [isBind, setIsBind] = useState(loginInfo.type === 'bind');
    const phoneVaildRef = useRef();
    const pwdTitle = useMemo(() => {
        let result;
        switch (accountType) {
            case 'NeteaseQiYeMail':
                result = getIn18Text('YOUXIANGMIMA');
                break;
            case '163Mail':
            case '126Mail':
            case 'QQMail':
            case 'Gmail':
                result = getIn18Text('SHOUQUANMA');
                break;
            case 'TencentQiye':
            case 'Others':
                result = getIn18Text('MIMASHOUQUANMA');
                break;
            default:
                result = getIn18Text('MIMASHOUQUANMA');
        }
        return result;
    }, [accountType]);
    const title = useMemo(() => {
        if (step === 'inputAccount') {
            return getIn18Text('TIANJIAYOUXIANGZHANG');
        }
        if (step === 'inputPwd') {
            if (isBind) {
                return getIn18Text('SHURU') + pwdTitle;
            }
            else {
                return getIn18Text('CHONGXINYANZHENGYOUXZH');
            }
        }
        return getIn18Text('SHOUJIDUANXINYAN');
    }, [isBind, step, pwdTitle, loginInfo]);
    const sureText = useMemo(() => {
        return step === 'inputAccount' ? getIn18Text('XIAYIBU') : getIn18Text('QUEREN');
    }, [step]);
    const authText = useMemo(() => {
        return authUrl ? (React.createElement("div", { className: styles.authTextWrap, onClick: () => {
                systemApi.openNewWindow(authUrl, false);
            } },
            React.createElement("div", { className: styles.authLine }),
            React.createElement("span", { className: styles.authText },
                " ",
                getIn18Text('SHOUQUANMAHUOQUSM')))) : null;
    }, [authUrl]);
    const fromEdmSend = loginInfo.way.includes('edmSend');
    const visiblePrevStep = (step === 'inputPwd' && loginInfo.type === 'bind' && !fromEdmSend) || step === 'phoneVaild';
    let OutlookBindLoopTimer;
    let OutlookBindLoopTimer1;
    const isOutlookLoop = useRef(false);
    const OutlookBindLoop = (accountPreId) => {
        clearTimer();
        isOutlookLoop.current = true;
        OutlookBindLoopTimer = setInterval(async () => {
            const loopRes = await mailApi.microsoftAuthLoop(accountPreId);
            const { accountPreId: accountPreIdRes, bindResult, errorCode } = loopRes || {};
            if (accountPreId === accountPreIdRes && bindResult !== undefined) {
                if (+bindResult !== 0) {
                    clearTimer();
                    setLoading(false);
                }
                if (+bindResult === 1) {
                    console.log(4444, '微软绑定成功');
                    const allSubAccountsFromServer = await accountApi.getAllSubAccounts();
                    await accountApi.subAccountsSyncLogin(allSubAccountsFromServer);
                    onBindSuccess();
                    eventApi.sendSysEvent({
                        eventName: 'mailChanged',
                        eventStrData: 'refreshFolder',
                        eventData: {
                            noCache: true,
                        },
                    });
                }
                if (+bindResult === 2) {
                    if (errorCode) {
                        if (+errorCode === 1) {
                            setErrMsg(getIn18Text('BANGDINGZHANGHSJGD'));
                        }
                        else if (+errorCode === 2) {
                            setErrMsg(getIn18Text('WEIRUANFANHSB'));
                        }
                        else if (+errorCode === 3) {
                            setErrMsg(getIn18Text('BANGDINGZHANGHAOSHIBAI'));
                        }
                    }
                }
            }
        }, 5000);
        OutlookBindLoopTimer1 = setTimeout(() => {
            clearTimer();
        }, 1000 * 60 * 10);
    };
    const clearTimer = () => {
        OutlookBindLoopTimer && clearInterval(OutlookBindLoopTimer);
        OutlookBindLoopTimer1 && clearTimeout(OutlookBindLoopTimer1);
        isOutlookLoop.current = false;
    };
    const getEmailConfig = useCallback(async (_account) => {
        var _a;
        const account = _account || ((_a = form.getFieldValue('account')) === null || _a === void 0 ? void 0 : _a.trim());
        try {
            const data = await mailApi.guessUserSetting(account);
            if (data) {
                const _accountType = getAccountType(data.domainType);
                setAccountType(_accountType);
                if (_accountType === 'Outlook') {
                    const authRes = await mailApi.microsoftAuth({ email: account, domainType: data.domainType, bindType: isBind ? 0 : 1 });
                    const { url, accountPreId } = authRes || {};
                    if (url) {
                        const width = 800;
                        const height = 600;
                        const currentLeft = window.screenLeft || window.screenX;
                        const currentTop = window.screenTop || window.screenY;
                        const currentWidth = window.innerWidth || document.documentElement.clientWidth;
                        const currentHeight = window.innerHeight || document.documentElement.clientHeight;
                        const left = currentLeft + (currentWidth - width) / 2;
                        const top = currentTop + (currentHeight - height) / 2;
                        if (process.env.BUILD_ISELECTRON) {
                            systemApi.openNewWindow(url, false);
                        }
                        else {
                            window.open(url, '_blank', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,location=no`);
                        }
                    }
                    if (accountPreId) {
                        OutlookBindLoop(accountPreId);
                    }
                    return _accountType;
                }
                else {
                    setVisibleSetting(_accountType === 'Others');
                    if (authMap.current && _accountType in authMap.current) {
                        setAuthUrl(authMap.current[_accountType]);
                    }
                    else {
                        setAuthUrl('');
                    }
                    form.setFieldsValue({
                        receiveHost: data.imapHost,
                        receivePort: data.imapPort || 993,
                        receiveSsl: data.receiveSsl || data.receiveSsl === null ? 1 : 0,
                        sendHost: data.smtpHost,
                        sendPort: data.smtpPort || 465,
                        sendSsl: data.sendSsl || data.receiveSsl === null ? 1 : 0,
                    });
                }
            }
            else {
                setVisibleSetting(true);
                setSettingError(getIn18Text('NINDEIMAPFUWU'));
            }
        }
        catch (e) {
            console.error('error', e);
            setVisibleSetting(true);
            setSettingError(getIn18Text('NINDEIMAPFUWU'));
        }
    }, []);
    useEffect(() => {
        getAuthCodeMap().then(res => {
            authMap.current = res;
            if (!authUrl && authMap.current) {
                setAccountType(_type => {
                    const url = authMap.current[_type];
                    if (url) {
                        setAuthUrl(url);
                    }
                    return _type;
                });
            }
        });
    }, []);
    const reBindAccount = useCallback(async (account) => {
        form.setFieldsValue({
            account,
        });
        setErrMsg('');
        setIsBind(false);
        setLoading(true);
        const accountInfo = await mailApi.microsoftAuthInfo(account);
        setLoading(false);
        const { domainType } = accountInfo || {};
        if (domainType && getAccountType(domainType) === 'Outlook') {
            setStep('inputAccount');
            setAccountType('Outlook');
            return;
        }
        const info = await getBindAccountInfo(account === null || account === void 0 ? void 0 : account.trim());
        if (info) {
            const _accountType = getAccountType(info.emailType);
            setStep('inputPwd');
            setVisibleSetting(_accountType === 'Others');
            setAccountType(_accountType);
            if (authMap.current && _accountType in authMap.current) {
                setAuthUrl(authMap.current[_accountType]);
            }
            else {
                setAuthUrl('');
            }
            form.setFieldsValue({
                receiveHost: info.receiveHost,
                receivePort: info.receivePort,
                receiveSsl: info.receiveSsl,
                sendHost: info.sendHost,
                sendPort: info.sendPort,
                sendSsl: info.sendSsl,
            });
        }
    }, [form]);
    const autoFillAccount = useCallback(async (account) => {
        setIsBind(true);
        form.setFieldsValue({
            account,
        });
        setAuthUrl;
        setErrMsg('');
        const _accountType = await getEmailConfig();
        if (_accountType === 'Outlook') {
            setStep('inputAccount');
        }
        else {
            setStep('inputPwd');
        }
    }, []);
    const edmSendTracker = useCallback((way, result) => {
        if (way.includes('edmSend')) {
            trackerApi.track('pcEdm_click_submit_inputPassword_addNewMailboxPage', {
                result,
            });
        }
    }, []);
    const onBindSuccess = useCallback(() => {
        var _a;
        const account = (_a = form.getFieldValue('account')) === null || _a === void 0 ? void 0 : _a.trim();
        message.success(successMessage || getIn18Text('BANGDINGCHENGGONG！'));
        sendAddAccountTrack(loginInfo.way, accountType, 'success');
        edmSendTracker(loginInfo.way, isBind ? 'bindSuccess' : 'reBindSuccess');
        setErrMsg('');
        trackerApi.track('pcEdm_click_submit_inputPassword_addNewMailboxPage', {
            success: account,
        });
        closeModel({ refresh: true, email: account });
    }, [accountType, isBind]);
    const onBindFail = useCallback((res, bindInfo) => {
        var _a, _b;
        if (res.errCode === 600) {
            setErrMsg('');
            setStep('phoneVaild');
            setMobile(res.errMsg);
            return;
        }
        if (res.errCode === 500) {
            setErrMsg(React.createElement(React.Fragment, null,
                getIn18Text('JIANCEDAONINXUYKQECDLYZ'),
                React.createElement("span", { className: styles.blue, onClick: () => {
                        loginApi.doOpenConfigPage();
                    } }, getIn18Text('，QINGQUWe'))));
        }
        else if (res.errCode === 800) {
            if (isElectron()) {
                const val = Object.assign(Object.assign({}, res), { _account: (_b = (_a = res) === null || _a === void 0 ? void 0 : _a.originReq) === null || _b === void 0 ? void 0 : _b.email });
                riskManage({
                    val,
                    callback: async () => {
                        var _a, _b;
                        await loginApi.handleAddSubAccountSuccess((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.originReq) === null || _b === void 0 ? void 0 : _b.email, () => { }, bindInfo);
                        onBindSuccess();
                    },
                });
            }
            else {
                setErrMsg(getIn18Text('DANGQIANDENGLHJCZFXQ14'));
            }
        }
        else if (res.errMsg) {
            setErrMsg(res.errMsg);
        }
        edmSendTracker(loginInfo.way, isBind ? 'bindFail' : 'reBindFail');
        sendAddAccountTrack(loginInfo.way, accountType, 'fail', res.errMsg);
        return;
    }, [accountType, isBind]);
    const bindNeteaseQiYeMail = useCallback(async () => {
        const formData = form.getFieldsValue();
        let { account, password } = formData;
        account = account === null || account === void 0 ? void 0 : account.trim();
        const agentNickname = getEmailSuffix(account)[0] || 'nickName';
        const bindInfo = isBind
            ? {
                agentEmail: account,
                password,
                accountType,
                agentNickname,
            }
            : {
                accountType: accountType === 'NeteaseQiYeMail' ? 'qyEmail' : 'personalEmail',
                agentEmail: account,
                password,
                agentNickname,
            };
        const promise = isBind ? loginApi.bindSubAccount(bindInfo) : accountApi.editSubAccount(bindInfo);
        const res = await promise;
        if (!res.success) {
            onBindFail(res, bindInfo);
            return;
        }
        onBindSuccess();
    }, [isBind, accountType, form]);
    const bindThirdMail = useCallback(async () => {
        const formData = form.getFieldsValue();
        let { account, password } = formData, sendReceiveInfo = __rest(formData, ["account", "password"]);
        account = account === null || account === void 0 ? void 0 : account.trim();
        const agentNickname = getEmailSuffix(account)[0] || 'nickName';
        const promise = isBind
            ? loginApi.bindSubAccount(Object.assign(Object.assign({}, sendReceiveInfo), { accountType, agentEmail: account, password,
                agentNickname }))
            : accountApi.editSubAccount(Object.assign(Object.assign({}, sendReceiveInfo), { agentEmail: account, password, accountType: loginInfo.accountType === 'NeteaseQiYeMail' ? 'qyEmail' : 'personalEmail', agentNickname: loginInfo.agentNickname || 'nickName' }));
        const res = await promise;
        if (!res.success) {
            onBindFail(res);
            return;
        }
        onBindSuccess();
    }, [accountType, form, isBind]);
    const onClose = useCallback(() => {
        closeModel({ refresh: false });
        clearTimer();
    }, []);
    const onPrevStep = useCallback(() => {
        setAuthUrl('');
        setErrMsg('');
        setSettingError('');
        if (step === 'inputPwd') {
            form.setFieldsValue({
                password: '',
            });
            setStep('inputAccount');
        }
        else if (step === 'phoneVaild') {
            setStep('inputPwd');
        }
    }, [step, isBind]);
    const onFinish = useCallback(async () => {
        var _a, _b;
        setLoading(true);
        try {
            if (step === 'inputAccount') {
                const account = (_a = form.getFieldValue('account')) === null || _a === void 0 ? void 0 : _a.trim();
                trackerApi.track('pc_mail_addEmail_emailCount', { submit: account });
                if (!(!isBind && accountType === 'Outlook')) {
                    const errorMessage = await getBindEmailMessage(account);
                    if (errorMessage) {
                        const isExpiredError = errorMessage === getIn18Text('BIND_SUBACCOUNT_EXPIRED');
                        const expiredError = (React.createElement(React.Fragment, null,
                            errorMessage,
                            React.createElement("span", { className: styles.blue, onClick: () => reBindAccount(account) }, getIn18Text('recheck'))));
                        setErrMsg(isExpiredError ? expiredError : errorMessage);
                        return;
                    }
                }
                trackerApi.track('pcEdm_click_submit_inputPassword_addNewMailboxPage', {
                    submit: account,
                });
                const _accountType = await getEmailConfig();
                setErrMsg('');
                if (_accountType === 'Outlook') {
                    setStep('inputAccount');
                }
                else {
                    setStep('inputPwd');
                }
                return;
            }
            if (step === 'inputPwd') {
                try {
                    const formData = form.getFieldsValue();
                    let { account } = formData;
                    account = account === null || account === void 0 ? void 0 : account.trim();
                    trackerApi.track('pc_mail_addEmail_emailCount', { success: account });
                }
                catch (error) { }
                setErrMsg('');
                if (accountType === 'NeteaseQiYeMail') {
                    await bindNeteaseQiYeMail();
                }
                else {
                    await bindThirdMail();
                }
                return;
            }
            if (step === 'phoneVaild') {
                await ((_b = phoneVaildRef.current) === null || _b === void 0 ? void 0 : _b.onLoginWithCode());
            }
        }
        catch (e) {
            console.error('onSubmit error', e);
        }
        finally {
            if (!isOutlookLoop.current) {
                setLoading(false);
            }
        }
    }, [step, isBind, getEmailConfig, form, accountType]);
    const onValuesChange = useCallback((changedValue) => {
        if (changedValue.hasOwnProperty('sendSsl')) {
            const sendSsl = changedValue.sendSsl;
            form.setFieldsValue({ sendPort: sendSsl ? 465 : 25 });
        }
        else if (changedValue.hasOwnProperty('receiveSsl')) {
            const receiveSsl = changedValue.receiveSsl;
            form.setFieldsValue({ receivePort: receiveSsl ? 993 : 143 });
        }
    }, [form]);
    const getValidatorFieldMessage = useCallback((value, field) => {
        let message = '';
        if (field === 'account') {
            if (!value) {
                message = getIn18Text('QINGSHURUYOUXIANGZHANG');
            }
            else if (!emailPattern.test(value.trim())) {
                message = getIn18Text('YOUXIANGZHANGHAOGESYW');
            }
        }
        else if (field === 'password') {
            if (!value) {
                message = getIn18Text('QINGSHURU') + pwdTitle;
            }
            else if (zhPattern.test(value)) {
                message = pwdTitle + getIn18Text('BUNENGYOUZHONGWEN');
            }
        }
        else if (!value.receiveHost || !value.sendHost) {
            message = getIn18Text('WEIHUOQUDAOFUWQDZ，QTX');
        }
        return message;
    }, [pwdTitle, step, accountType]);
    const renderAccount = () => {
        return (React.createElement(Form.Item, { hidden: step !== 'inputAccount', className: styles.accountWrap, validateStatus: errMsg ? 'error' : undefined, help: errMsg ? React.createElement(ErrorMsg, { message: errMsg }) : undefined, rules: [
                () => ({
                    validator(_, value) {
                        const msg = getValidatorFieldMessage(value, 'account');
                        return msg ? Promise.reject(React.createElement(ErrorMsg, { message: msg })) : Promise.resolve();
                    },
                }),
            ], validateTrigger: false, name: "account", label: React.createElement("span", { className: classnames(styles.label) },
                getIn18Text('SHURUNINYAOTIANJDYXZH'),
                "\uFF1A") },
            React.createElement(AccountAutoComplete, { disabled: loading })));
    };
    const renderPwd = () => {
        return step === 'inputPwd' ? (React.createElement(Form.Item, { rules: [
                () => ({
                    validator(_, value) {
                        const msg = getValidatorFieldMessage(value, 'password');
                        return msg ? Promise.reject(React.createElement(ErrorMsg, { message: msg })) : Promise.resolve();
                    },
                }),
            ], validateStatus: errMsg ? 'error' : undefined, help: errMsg ? React.createElement(ErrorMsg, { message: errMsg }) : undefined, validateTrigger: false, name: "password", label: React.createElement("span", { className: styles.passwordLabel },
                form.getFieldValue('account') + getIn18Text('DE') + pwdTitle,
                "\uFF1A") },
            React.createElement(InputPassword, { autoFocus: true, disabled: loading, suffix: authText, placeholder: getIn18Text('QINGSHURU') + pwdTitle }))) : null;
    };
    const renderSetting = () => {
        return step === 'inputPwd' && accountType !== 'NeteaseQiYeMail' ? (React.createElement(Form.Item, { noStyle: true },
            React.createElement("div", { className: styles.settingWrap },
                React.createElement("div", { className: styles.setting, onClick: () => {
                        setVisibleSetting(!visibleSetting);
                    } },
                    React.createElement("div", { className: styles.textLine }),
                    React.createElement("div", { className: styles.text },
                        React.createElement("span", null, getIn18Text('GAOJISHEZHI')),
                        visibleSetting ? (React.createElement(TongyongJiantou1Shang, { wrapClassName: styles.iconWrap, className: styles.icon })) : (React.createElement(TongyongJiantou1Xia, { wrapClassName: styles.iconWrap, className: styles.icon }))),
                    React.createElement("div", { className: styles.textLine })),
                React.createElement("div", { className: styles.hostContainer, hidden: !visibleSetting },
                    React.createElement("div", { className: styles.hostWrap },
                        React.createElement(Form.Item, { label: getIn18Text('IMAPFUWUQI') + '：', name: "receiveHost", className: classnames(styles.host), rules: [
                                ({ getFieldsValue }) => ({
                                    validator(_, value) {
                                        const msg = getValidatorFieldMessage(getFieldsValue());
                                        setSettingError(msg);
                                        return !value ? Promise.reject() : Promise.resolve();
                                    },
                                }),
                            ] },
                            React.createElement(Input, { disabled: loading, placeholder: getIn18Text('QINGSHURU') + getIn18Text('IMAPFUWUQI'), allowClear: true })),
                        React.createElement(Form.Item, { name: "receiveSsl", className: styles.ssl, label: getIn18Text('JIAMI') + '：' },
                            React.createElement(EnhanceSelect, { disabled: loading, options: [
                                    { value: 1, label: 'SSL' },
                                    { value: 0, label: getIn18Text('WU') },
                                ] })),
                        React.createElement(Form.Item, { name: "receivePort", label: getIn18Text('DUANKOU') + '：', className: classnames(styles.port) },
                            React.createElement(Input, { placeholder: getIn18Text('XUANTIAN'), disabled: loading }))),
                    React.createElement("div", { className: styles.hostWrap },
                        React.createElement(Form.Item, { label: getIn18Text('SMTPFUWUQI') + '：', name: "sendHost", rules: [
                                ({ getFieldsValue }) => ({
                                    validator(_, value) {
                                        const msg = getValidatorFieldMessage(getFieldsValue());
                                        setSettingError(msg);
                                        return !value ? Promise.reject() : Promise.resolve();
                                    },
                                }),
                            ], className: classnames(styles.host) },
                            React.createElement(Input, { disabled: loading, placeholder: getIn18Text('QINGSHURU') + getIn18Text('SMTPFUWUQI'), allowClear: true })),
                        React.createElement(Form.Item, { name: "sendSsl", className: styles.ssl, label: getIn18Text('JIAMI') + '：' },
                            React.createElement(EnhanceSelect, { disabled: loading, options: [
                                    { value: 1, label: 'SSL' },
                                    { value: 0, label: getIn18Text('WU') },
                                ] })),
                        React.createElement(Form.Item, { name: "sendPort", label: getIn18Text('DUANKOU') + '：', className: classnames(styles.port) },
                            React.createElement(Input, { placeholder: getIn18Text('XUANTIAN'), disabled: loading })))),
                React.createElement("div", { className: styles.settingErrorWrap },
                    React.createElement(ErrorMsg, { message: settingError }))))) : null;
    };
    const renderPhoneValid = () => {
        return step === 'phoneVaild' ? React.createElement(PhoneVaild, { mobile: mobile, onBindSuccess: onBindSuccess, onBindFail: onBindFail, ref: phoneVaildRef }) : null;
    };
    useEffect(() => {
        if ((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.type) === 'rebind' && (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.agentEmail)) {
            reBindAccount(loginInfo.agentEmail);
        }
        else if (loginInfo.way.includes('edmSend') && (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.type) === 'bind' && (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.agentEmail)) {
            autoFillAccount(loginInfo.agentEmail);
        }
    }, [loginInfo]);
    useEffect(() => {
        const newAccountTypes = [...accountTypes];
        if (productAuthApi.getABSwitchSync('disable_ui_binding_gmail')) {
            newAccountTypes.splice(newAccountTypes.indexOf('Gmail'), 1);
        }
        if (productAuthApi.getABSwitchSync('disable_ui_binding_qiyeqq')) {
            newAccountTypes.splice(newAccountTypes.indexOf('TencentQiye'), 1);
        }
        if (newAccountTypes.length !== accountTypes.length) {
            setAccountTypes(newAccountTypes);
        }
    }, []);
    const enterStep2 = async (_account) => {
        form.setFieldsValue({ account: _account });
        const _accountType = await getEmailConfig(_account);
        setErrMsg('');
        if (_accountType === 'Outlook') {
            setStep('inputAccount');
        }
        else {
            setStep('inputPwd');
        }
    };
    useEffect(() => {
        if (!initStepData)
            return;
        const { purpose, email } = initStepData;
        if (purpose === 'intoStep2') {
            enterStep2(email);
        }
        if (purpose === 'reBind') {
            form.setFieldsValue({ account: email });
            reBindAccount(email);
        }
        setInitStepData(undefined);
    }, [initStepData]);
    return (React.createElement(SiriusHtmlModal, { visible: true, closable: false, width: 480 },
        React.createElement("div", { className: styles.modalWrap },
            React.createElement("div", { className: styles.title }, renderTitle ? renderTitle() : title),
            renderSubTitle && React.createElement("div", { className: styles.subTitle }, renderSubTitle()),
            React.createElement("div", { className: styles.content },
                React.createElement(Form, { hidden: step === 'phoneVaild', layout: "vertical", form: form, onValuesChange: onValuesChange, onFinish: onFinish },
                    renderPwd(),
                    renderAccount(),
                    renderSetting()),
                renderPhoneValid()),
            React.createElement("div", { className: styles.footer },
                React.createElement(Button, { btnType: "minorLine", onClick: onClose }, getIn18Text('QUXIAO')),
                visiblePrevStep && (React.createElement(Button, { btnType: "minorLine", onClick: onPrevStep }, getIn18Text('SHANGYIBU'))),
                React.createElement(Button, { btnType: "primary", loading: loading, disabled: loading, "data-test-id": step === 'inputAccount' ? 'sub-account-next-step-btn' : 'sub-account-add-ok-btn', onClick: () => {
                        form.submit();
                    } }, sureText)))));
};
const MultAccountsLoginModal = (props) => {
    const { visible } = props, opt = __rest(props, ["visible"]);
    return visible ? React.createElement(MultAccountsLogin, Object.assign({}, opt)) : null;
};
const AccountAutoComplete = (props) => {
    const { onChange, disabled, value } = props;
    const [options, setOptions] = useState([]);
    const onSearch = useCallback((value) => {
        if (!value || zhPattern.test(value)) {
            setOptions([]);
            return;
        }
        const valueArr = value.split('@');
        if (valueArr.length > 2) {
            setOptions([]);
            return;
        }
        const opts = [];
        domainList.forEach(domain => {
            if (valueArr.length === 1) {
                opts.push({
                    value: value + '@' + domain,
                    label: value + '@' + domain,
                });
            }
            else if (domain.startsWith(valueArr[1])) {
                opts.push({
                    value: valueArr[0] + '@' + domain,
                    label: valueArr[0] + '@' + domain,
                });
            }
        });
        setOptions(opts);
    }, []);
    return (React.createElement(AutoComplete, { options: options, allowClear: true, backfill: true, autoFocus: true, disabled: disabled, defaultActiveFirstOption: true, dropdownClassName: styles.inputPopupWrap, onChange: onChange, "data-test-id": "sub-account-email-input", value: value, autoComplete: "new-password", className: styles.inputWrap, notFoundContent: null, placeholder: getIn18Text('QINGSHURUYOUXIANGZHANG'), onSearch: onSearch, onSelect: value => {
            onChange && onChange(value);
        } }));
};
const InputPassword = (props) => {
    const { suffix } = props, opt = __rest(props, ["suffix"]);
    const passwordRef = useRef();
    useEffect(() => {
        setTimeout(() => {
            var _a;
            (_a = passwordRef === null || passwordRef === void 0 ? void 0 : passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 500);
    }, []);
    return (React.createElement("div", { className: styles.passwordWrap },
        React.createElement(Input.Password, Object.assign({ ref: passwordRef, autoComplete: "new-password", "data-test-id": "sub-account-email-pwd-input", className: classnames(styles.password, {
                [styles.hasSuffix]: !!suffix,
            }) }, opt)),
        suffix));
};
const ErrorMsg = ({ message }) => {
    return message ? (React.createElement("span", { className: styles.errorMsgWarp },
        React.createElement(TongyongCuowutishiMian, { className: styles.icon, wrapClassName: styles.iconWrap }),
        React.createElement("span", { className: styles.text }, message))) : null;
};
const resendCodeWaitSpan = 60;
const PhoneVaild = React.forwardRef((props, ref) => {
    const { mobile, onBindSuccess, onBindFail } = props;
    const [code, setCode] = useState();
    const [loading, setLoading] = useState();
    const [time, setTime] = useState(resendCodeWaitSpan);
    const [warning, setWarning] = useState();
    useImperativeHandle(ref, () => ({
        onLoginWithCode,
    }));
    const keyDownHandler = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onLoginWithCode();
        }
    }, []);
    const startCountDown = useCallback(() => {
        setTime(prev => {
            setTimeout(() => {
                if (prev > 0) {
                    if (prev > 5) {
                    }
                    startCountDown();
                }
                else {
                    setTime(resendCodeWaitSpan);
                }
            }, 1000);
            return prev > 0 ? prev - 1 : 0;
        });
    }, []);
    const onGetCode = useCallback(async () => {
        if (loading) {
            return;
        }
        const res = await loginApi.sendBindAccountVerifyCode();
        if (res.success) {
            startCountDown();
        }
        else {
            setWarning(res.errMsg || '');
        }
    }, []);
    const onLoginWithCode = useCallback(async () => {
        if (!code) {
            setWarning(getIn18Text('QINGSHURU') + getIn18Text('YANZHENGMA'));
            return;
        }
        if (loading) {
            return;
        }
        setLoading(true);
        setWarning('');
        const res = await loginApi.bindAccountLoginWithCode(code);
        setLoading(false);
        if (res.success) {
            onBindSuccess();
            return;
        }
        if (res.errMsg) {
            setWarning(res.errMsg);
        }
    }, [code, loading]);
    useEffect(() => {
        if (mobile) {
            onGetCode();
        }
    }, [mobile]);
    if (!mobile) {
        return null;
    }
    return (React.createElement("div", { className: styles.phoneVaildWrap },
        React.createElement("div", { className: styles.uPhone },
            getIn18Text('YANZHENGMAYITONG'),
            React.createElement("span", { className: "blue" }, mobile)),
        React.createElement("div", { className: styles.uInput },
            React.createElement(Input, { autoFocus: true, allowClear: true, disabled: loading, maxLength: 6, className: styles.uCodeInput, placeholder: getIn18Text('QINGSHURU6WEI'), value: code, status: warning ? 'error' : undefined, onChange: e => {
                    setCode(e.target.value);
                }, onKeyDown: keyDownHandler }),
            React.createElement("div", { className: styles.uCodeText }, time < resendCodeWaitSpan ? (`${time}s后重试`) : (React.createElement("span", { className: "blue", onClick: onGetCode }, getIn18Text('HUOQUYANZHENGMA'))))),
        React.createElement("div", { className: styles.errorWrap },
            React.createElement(ErrorMsg, { message: warning }))));
});
export default MultAccountsLoginModal;
